import { useChartDataWithTranslations } from 'components/charts/inc-charts.hooks';
import {
  percentageSeries,
  percentageValueFormatter,
} from 'components/charts/inc-charts.utils';
import IncLineChart from 'components/charts/inc-line-chart/inc-line-chart.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import { dateXAxis } from 'pages/loyalty-performance-report/loyalty-performance-report.utils';
import { useTranslation } from 'react-i18next';

const yAxisValueFormatter = percentageValueFormatter(2);

const FranchiseActiveMembers = () => {
  const { t } = useTranslation();
  const {
    data,
    queryState: { isFetching },
  } = useSearchQueryContext('franchiseActiveMembers');
  const series = useChartDataWithTranslations(
    data?.series,
    label => `page.loyaltyPerformanceReport.members.${label}.label`,
  );

  return (
    <IncLineChart
      series={percentageSeries(series)}
      title={t('page.loyaltyPerformanceReport.members.title')}
      data-testid="FranchiseActiveMembers"
      LineChartProps={{
        loading: isFetching,
        xAxis: [dateXAxis(data?.xlabels)],
        yAxis: [{ valueFormatter: yAxisValueFormatter, id: 'leftAxisId' }],
      }}
    />
  );
};

export default FranchiseActiveMembers;
